import { useContext } from 'react';
import { Card } from '../components/ui/cards'
import { Mail, MapPin, Phone } from "lucide-react";
import Context from '../../common/components/utils/context';

export const Contact = () => {
    const context = useContext(Context)
    const contact = {
      "title": "Get in Touch",
      "subtitle": "Ready to see FoundAt in action? Contact us for a personalized demo.",
      "email": "Email",
      "phone": "Phone",
      "location": "Location",
      "locationText": "Ground Floor, 35 Ventnor Avenue, West Perth, Western Australia 6005"
    }
  return (
    <section ref={context.homepageSections.contact} id="contact" className="relative py-20 bg-gradient-to-b from-white to-home-secondary">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.5)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.5)_1px,transparent_1px)] bg-[size:40px_40px] z-10"></div>
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 z-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-home-primary to-home-accent bg-clip-text text-transparent mb-4">{contact.title}</h2>
          <p className="text-xl text-home-muted-foreground max-w-2xl mx-auto">
            {contact.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <Card className="p-6 text-center hover:shadow-lg-custom transition-shadow">
            <div className="w-12 h-12 rounded-full bg-home-accent/10 flex items-center justify-center mx-auto mb-4">
              <Mail className="w-6 h-6 text-home-accent" />
            </div>
            <h3 className="text-lg font-semibold text-home-foreground mb-2">{contact.email}</h3>
            <a
              href="mailto:enquiries@foundat.com"
              className="text-home-muted-foreground hover:text-home-accent transition-colors"
            >
              enquiries@foundat.com
            </a>
          </Card>

          <Card className="p-6 text-center hover:shadow-lg-custom transition-home-shadow">
            <div className="w-12 h-12 rounded-full bg-home-accent/10 flex items-center justify-center mx-auto mb-4">
              <Phone className="w-6 h-6 text-home-accent" />
            </div>
            <h3 className="text-lg font-semibold text-home-foreground mb-2">{contact.phone}</h3>
            <a
              href="tel:+61411250833"
              className="text-home-muted-foreground hover:text-home-accent transition-colors"
            >
              +61 411 250 833
            </a>
          </Card>

          <Card className="p-6 text-center hover:shadow-lg-custom transition-shadow">
            <div className="w-12 h-12 rounded-full bg-home-accent/10 flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-6 h-6 text-home-accent" />
            </div>
            <h3 className="text-lg font-semibold text-home-foreground mb-2">{contact.location}</h3>
            <p className="text-home-muted-foreground">
              {contact.locationText}
            </p>
          </Card>
        </div>
      </div>
    </section>
  );
};
